import React from 'react';
import { Button } from '@fourthwall/components';
import { DomainString } from '../DomainString/DomainString';
import * as S from './DomainSuggestions.styled';
export const DomainSuggestions = ({ title = 'Alternative options:', suggestions, claimLabel = 'Claim', isClaiming, onClaim, }) => {
    const renderSuggestion = (suggestion) => {
        return (React.createElement(S.SuggestionItem, null,
            React.createElement(S.DomainName, null,
                React.createElement(DomainString, { domain: suggestion })),
            React.createElement(Button, { label: claimLabel, size: "xsmall", loading: isClaiming, onClick: () => onClaim(suggestion) })));
    };
    return (React.createElement("div", null,
        React.createElement(S.Header, null, title),
        suggestions.map(renderSuggestion)));
};
